<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  name: "Edit",
  data() {
    return {
      otp: false,
      voter_id:'',
      required_degree: {},
      ApiResponse: {
        token : null
      },
      nationalities: {},
      required_files: {},
      NumOfrequired_files: 0,
      errors: {
        fullName: "",
        phoneNumber: "",
        UNIName: "",
        EDUlocation: "",
        Nationality: "",
        birthdate: "",
        email: "",
        institution: "",
        requiredfiles: "",
        Gender: "",
        passportNumber: "",
        NatNumber: "",
      },
      policy: {},
      admission_limit: {},
      required_experience: {},
      categories: {},
      theCategory: {},
      subCategories: {},
      subCategory: {},
      isLoading: false,
      institutions: {},
      degrees: {},
      isDragOver: false,
      page: 8,
      attachedFiles: [],
      nid:'',
      items: ["Item 1", "Item 2", "Item 3"],
      personalInfo: {
        reference_number: "",
        token: "",
        id: "",
        otp: "",
        EDUlocation: "بلد التحصل عليها",
        UNIName: "",
        FullName: "",
        Gender: "الجنس",
        Nationality: "136",
        nationalId: "",
        passportNumber: "",
        phone: "",
        birthDate: "",
        email: "",
        education: "المؤهل العلمي",
        experience: "",
        category: "الفئة المتقدم لها",
        centre: [],
        institution: [],
      },
      success: false,
      loading: false,
      selectedmunicipality: null,
      servererrors: null,
      info: {},
      cities: [
        {
          id: 1,
          name: "البيضاء",
        },
        {
          id: 2,
          name: "اجدابيا",
        },
        {
          id: 3,
          name: "بنغازي",
        },
      ],
      municipalities: [],
    };
  },
  methods: {
    async login() {
 
      this.isLoading = true;
      const loadingDialog = Swal.fire({
        title: "جاري التحميل",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .post(
          "/voter/send_otp",
          {
            phone_number: this.personalInfo.phoneNumber,
            nid:this.personalInfo.nid
          }
        )
        .then((response) => {
          console.log(response);
          // this.personalInfo.id = response.data.voter.id;

        
          if (response.status == 200) {
            loadingDialog.close();
            this.otp = true;
            this.voter_id = response.data.voter_id;

            // Swal.fire({
            //   title: "تم الإرسال بنجاح",
            //   icon: "success",
            //   timer: 1000,
            //   timerProgressBar: true,
            //   showConfirmButton: false,
            // });
          }
        })
        .catch((error) => {
          this.otp = false;
          if (error.response.status == 422) {
            this.otp = false;
          Swal.fire({
            text:  "عفواً تم تعديل بياناتك مسبقاً",
            icon: "error",
            allowOutsideClick: false,
          });
          }else{
          console.log(error)
          Swal.fire({
            text:  "رقم الوطني او رقم الهاتف المدخل غير مسجل بالمنصة",
            icon: "error",
            allowOutsideClick: false,
          });}
        });
      return this.apiResponse;
    },
    // validateOTP
    // this function will work when the user click on the next button
    // it will validate the OTP code
    // if the code is correct it will move to the next page
    // if the code is incorrect it will show an error message
    validateOTP() {
      const formData = new FormData();
      formData.append("otp", this.personalInfo.otp);
      formData.append("voter_id", this.voter_id);
      this.isLoading = true;
      const loadingDialog = Swal.fire({
        title: "جاري التحميل",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .post(
          "/voter/verify_otp",
          formData
        )
        .then((response) => {
          this.ApiResponse = response.data;
          this.info = response.data.user;
 

          this.selectedmunicipality = this.municipalities.find(obj => {
            return obj.id === response.data.user.municipality_id;
          });


          this.info.electionCenterNo =  response.data.user.election_center_id;

          if (response.status == 200) {

            this.isLoading = false;
            loadingDialog.close();
 
            // Swal.fire({
            //   title: "تم الإرسال بنجاح",
            //   icon: "success",
            //   timer: 1000,
            //   timerProgressBar: true,
            //   showConfirmButton: false,
            // });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            text: "الرجاء التأكد من الرمز المرسل",
            icon: "error",
            showConfirmButton: true,
            allowOutsideClick: false,
          });
        });
    },
    send() {
      console.log(this.info);
      this.loading = true;



      this.info.registeredBy = "webapp";
      this.info.municipalId = this.selectedmunicipality.id;
      this.info.residence = this.selectedmunicipality.code;

      const config = {
    headers: { Authorization: `Bearer ${this.ApiResponse.token}` }
};

      axios.post("/mobile/voters/update", this.info,config).then(
        (response) => {
          console.log(response);
          if (response.status == 200) {
            this.success = true;
            this.loading = false;
          } else {
            this.servererrors = response.data.message;
            this.loading = false;
          }
        },
        (error) => {
          this.servererrors = error.response.data.message;
          this.loading = false;
        }
      );
    },
    getToken() {
      this.personalInfo.token = this.ApiResponse.token;
      this.personalInfo.expires_at = this.ApiResponse.expires_at;
      localStorage.setItem("token", this.personalInfo.token);
      localStorage.setItem("expires_at", this.personalInfo.expires_at);
    },
  },

  mounted() {
    axios.get("mobile/municipalities/").then(
      (response) => {
        console.log(response);
        if (response.status == 200) {
          this.municipalities = response.data.data;
        } else {
          this.servererrors = response.data.message;
        }
      },
      (error) => {
        this.servererrors = error.response.data.message;
      }
    );
  },
  computed: {
    haspolicy() {
      return this.policy.length > 0;
    },
    isValid() {
      return !Object.values(this.errors).some((error) => error !== "");
    },
  },
};
</script>
<template>
  <div v-if="!ApiResponse.token">
 

    <div class=" max-w-xl   w-[28.125rem] mx-auto p-10 mt-36" >
        <div class="mb-4">
            <img
          class="object-cover object-center rounded justify-center mx-auto w-48 mb-4"
          alt="hero"
          src=".././assets/ccme-logo.png"
        />
        <h3
          class="text-xl leading-9 tracking-tight font-bold text-primary-900 sm:text-3xl sm:leading-10 text-center"
        >
          تعديل بيانات </h3>
      </div>
      <ValidationObserver
          v-slot="{ handleSubmit, errors  }"
          v-if="!success"
        >
      <form
            @submit.prevent="handleSubmit(login)"
           
          >
      <div class="w-fit mx-auto justify-center my-4 mb-10   text-right" v-if="!otp">
        <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الرقم الوطني</label
              >

              <ValidationProvider
                name="nid"
                rules="required|digits:12|regex:^[1-2].*"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="nid"
                    v-model="personalInfo.nid"
                    type="number"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div>
        <div class="sm:col-span-4 mt-5">
              <label
                for="mobile1"
                class="block text-lg font-bold leading-5 text-gray-900"
                >رقم الهاتف</label
              >
              <ValidationProvider
                name="mobile1"
                rules="required|regex:^09\d{8}$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="personalInfo.phoneNumber"
                    type="number"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

      </div>

      <div class="w-fit mx-auto justify-center my-4 mb-10 text-right" v-if="otp">


        <div class="sm:col-span-4 mt-5">
              <label
                for="mobile1"
                class="block text-lg font-bold leading-5 text-gray-900"
                >رمز التحقق</label
              >
             
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                  v-model="personalInfo.otp"
                    type="number"
                    required
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                
                  />
                </div>
             
            </div>
 
        <p class="font-Almarai text-red-500" v-if="errors.otp">
          *{{ errors.otp }}
        </p>
      </div>

 
      <div class="mt-1 sm:mt-2" v-if="!otp">
            <span class="flex w-full rounded-md shadow-sm">
              <button
              type="submit"
         
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
              متابعة
            </button>
            </span>
          </div>

      <div class="mt-1 sm:mt-2" v-else>
            <span class="flex w-full rounded-md shadow-sm">
              <a
               @click="validateOTP()"
         
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
              متابعة
            </a>
            </span>
          </div>
</form>
      </ValidationObserver>
 
    </div>
  </div>
  <div
  v-else
    class="bg-cool-gray-50 py-4 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-12"
  >
    <div class="relative max-w-xl mx-auto">
      <div class="mb-4">
        <img
          class="object-cover object-center rounded justify-center mx-auto w-48 mb-4"
          alt="hero"
          src=".././assets/ccme-logo.png"
        />
        <h3
          class="text-xl leading-9 tracking-tight font-bold text-primary-900 sm:text-3xl sm:leading-10 text-center"
        >
          تعديل بيانات التسجيل 
        </h3>
      </div>

 
      <div class="pt-8 border-t-2 border-gray-300 mt-10">
        <ValidationObserver
          v-slot="{ handleSubmit, errors, invalid, failed }"
          v-if="!success"
        >
          <form
            @submit.prevent="handleSubmit(send)"
            class="grid grid-cols-1 row-gap-6 sm:grid-cols-4 sm:col-gap-8 text-right"
          >


            <div class="sm:col-span-4 pt-8 border-t-2 mt-1 mb-2">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                البيانات الشخصية
              </h3>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                لتأكيد الهوية و المصادقة على البيانات
              </p>
            </div>

            <div>
              <label
                for="first_name"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الاسم الأوّل</label
              >
              <ValidationProvider
                name="firstName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.first_name"
                    disabled
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150 bg-gray-100"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div>
              <label
                for="secondName"
                class="block text-lg font-bold leading-5 text-gray-900"
                >اسم الأب</label
              >
              <ValidationProvider
                name="secondName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.father_name"
                    disabled
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150 bg-gray-100"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div>
              <label
                for="thirdName"
                class="block text-lg font-bold leading-5 text-gray-900"
                >اسم الجد</label
              >
              <ValidationProvider
                name="thirdName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.grand_father_name"
                    disabled
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150 bg-gray-100"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div>
              <label
                for="lastName"
                class="block text-lg font-bold leading-5 text-gray-900"
                >اللقب</label
              >
              <ValidationProvider
                name="lastName"
                rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    v-model="info.family_name"
                    disabled
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150 bg-gray-100"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الرقم الوطني</label
              >

              <ValidationProvider
                name="nid"
                rules="required|digits:12|regex:^[1-2].*"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="nid"
                    disabled
                    v-model="info.nid"
                    type="number"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center  bg-gray-100"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div>
            <!-- <div class="sm:col-span-4">
              <label
                for="familyBookid"
                class="block text-lg font-bold leading-5 text-gray-900"
              >
                رقم القيد</label
              >
              <ValidationProvider
                name="registration_number"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="registration_number"
                    v-model="info.registration_number"
                    type="text"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p 
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div> -->

            <div class="sm:col-span-4 mb-2">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                بيانات الاقتراع
              </h3>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                الرّجاء إدخال بيانات البلدية والمركز الانتخابي الذي تنوي
                الانتخاب فيه
              </p>
            </div>

            <div class="sm:col-span-4">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >البلدية</label
              >
              <ValidationProvider
                name="municipality"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <select
                    id="type"
                    v-model="selectedmunicipality"
                    class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  >
                    <option selected disabled :value="null">اختر</option>
                    <option
                      v-for="municipality in municipalities"
                      :key="municipality.id"
                      :value="municipality"
                      class="font-bold"
                    >
                      {{ municipality.name }}
                    </option>
                  </select>
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-if="v.errors[0] != null"
                >
                  {{ v.errors[0] }}ة
                </p>
              </ValidationProvider>
            </div>

            <div class="sm:col-span-4" v-if="selectedmunicipality">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >مركز الاقتراع</label
              >
              <ValidationProvider
                name="electionCenterNo"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <select
                    v-model="info.electionCenterNo"
                    class="mt-1 systemfont font-bold form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  >
                    <option selected disabled :value="null">اختر</option>
                    <option
                      v-for="center in selectedmunicipality.election_centers"
                      :key="center.id"
                      :value="center.id"
                      class="font-bold systemfont"
                    >
                      {{ center.name }}
                      <span class="systemfont"  
                        >- منطقة {{ center.area_name }}
                      </span>
                    </option>
                  </select>
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                >
                  {{ v.errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div
              class="sm:col-span-4 mb-2 pt-8 border-t-2 mt-1"
              v-if="selectedmunicipality && info.registration_type=='unregistered_resident'"
            >
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                بيانات الإقامة
              </h3>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                الرّجاء إدخال البيانات وفقاً للسجلات الرّسمية
              </p>
            </div>
       

            <div class="sm:col-span-4"  v-if="selectedmunicipality && info.registration_type=='unregistered_resident'">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الإقامة و القيد </label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="type"
                  v-model="info.registration_type"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg text-center"
                >
                  <option selected disabled :value="null">اختر</option>
                  <option selected :value="'registered_resident'">
                    مقيم و مقيد بمكاتب السجل المدني ب{{ selectedmunicipality.name }}
                  </option>
                  <option :value="'unregistered_resident'">
                    مقيم و غير مقيد بمكاتب السجل المدني ب{{ selectedmunicipality.name }}
                  </option>
                </select>
              </div>
            </div>
 

            <div
              class="sm:col-span-4 mt-2"
              v-if="(invalid && failed) || servererrors != null"
            >
              <div class="rounded-md bg-red-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <!-- Heroicon name: x-circle -->
                    <svg
                      class="h-5 w-5 text-red-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="mr-3">
                    <h3 class="text-base leading-5 font-medium text-red-500">
                      هناك أخطاء في إدخالك للحقول يجب معالجتها قبل الاستمرار
                    </h3>
                    <div
                      class="mt-2 text-base leading-5 text-red-700"
                      v-if="servererrors != null"
                    >
                      <ul class="list-disc pr-5">
                        <li class="mt-1">
                          {{ servererrors }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sm:col-span-4 mt-1">
              <span class="w-full inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-lg leading-6 font-bold rounded-md text-white bg-primary-500 hover:bg-primary-500 font focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                >
                  <svg
                    v-if="loading"
                    class="animate-spin -mr-1 ml-3 h-5 w-5 text-yellow-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>

                  تسجيل
                </button>
              </span>
            </div>
          </form>
        </ValidationObserver>
        <div
          class="block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all mb-12"
          role="dialog"
          v-else
        >
          <div>
            <div
              class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100"
            >
              <!-- Heroicon name: check -->
              <svg
                class="h-10 w-10 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <div class="mt-4 text-center sm:mt-5">
              <h3 class="text-lg font-bold leading-10 text-gray-900">
                تم ارسال طلب تعديل بياناتكم بنجاح
              </h3>
              <!-- <div class="mt-2">
                <p class="text-xl font-medium leading-7 text-gray-600">
                    سوف يتم ارسال رقمكم الانتخابي خلال <span class="systemfont font-bold"> 24 </span>  ساعة بعد إتمام التأكد من صحة البيانات التي تم إدخالها
                </p>
              </div> -->
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <router-link
                to="/enquiry"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
               للإستفســار عن تسجيل
              </router-link>
            </span>
          </div>
          <!-- <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <router-link
                to="/"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                عودة للرئيسية
              </router-link>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
  direction: ltr;
}

input[type="email"] {
  direction: ltr;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.animate-spin {
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>